export type CyCssClass =
    'cy-main-screen' |
    'cy-brand-switch-list' |
    'cy-brand-switch-list-item' |
    'cy-menu-link' |
    'cy-spinner' |
    'cy-game-iframe' |
    'cy-single-game-regular-template' |
    'cy-game-image-container' |
    'cy-play-real-game-button' |
    'cy-play-demo-game-button' |
    'cy-modal' |
    'cy-modal-content' |
    'cy-reality-check-options' |
    'cy-modal-dialog-buttons-area' |
    'cy-welcome-component' |
    'cy-balance-box' |
    'cy-balance-box-amount' |
    'cy-profile-box' |
    'cy-cashier-button' |
    'cy-clock' |
    'cy-game-window' |
    'cy-logout-link' |
    'cy-burger-button' |
    'cy-profile-box-login-button' |
    'cy-menu-links-group' |
    'cy-profile-picture' |
    'cy-menu-item' |
    'cy-game-navbar-close-button' |
    'cy-game-navbar-clock' |
    'cy-game-stripe-clock' |
    'cy-game-navbar' |
    'cy-open-responsible-gaming-button' |
    'cy-game-navbar-game-name' |
    'cy-game-navbar-session-id' |
    'cy-game-navbar-switch-to-real-label' |
    'cy-game-navbar-switch-to-demo-label' |
    'cy-game-navbar-game-mode-toggle' |
    "cy-game-info-page-button" |
    'cy-welcome-cashier-button' |
    'cy-game-navbar-fullscreen-button' |
    'cy-game-regulation-stripe' |
    'cy-spain-game-limit-duration-select' |
    'cy-spain-game-limit-confirmation-dialog-title' |
    'cy-spain-game-limit-loss-limit-select' |
    'cy-spain-game-limit-interval-reminder-select' |
    'cy-spain-game-limit-restriction-period-select' |
    'cy-header-regulation-data'|
    'cy-self-exclusion-link' |
    'cy-safe-to-play' |
    'cy-responsible-gaming-button' |
    'cy-balance-amount-pc' |
    'cy-header-bankroll-button-mobile' |
    'cy-bonus-and-cash-balance' |
    'cy-cache-balance' |
    'cy-bonus-balance' |
    'cy-login-button-text' |
    'cy-register-button' |
    'cy-last-login-label' |
    'cy-main-nav' |
    'cy-navbar-mobile-wrapper' |
    'cy-session-timer' |
    'cy-last-login-value' |
    'cy-open-game-intermediate-page' |
    'cy-regulation-game-session-id' |
    'cy-regulation-participation-ticket-id' |
    'cy-italy-game-limit-default-amount-option' |
    'cy-italy-game-limit-other-amount-option' |
    'cy-italy-game-limit-other-amount-input' |
    'cy-italy-game-limit-regulatory-value' |
    'cy-sweden-panic-button' |
    'cy-sweden-game-limit-button' |
    'cy-sweden-self-test-button' |
    'cy-modal-dialog-x-close-button' |
    'cy-external-link-container' |
    'cy-cashier-external-link-container' |
    'cy-new-live-casino' |
    'cy-live-casino' |
    'cy-live-casino-widget-container' |
    'cy-modal-main-title' |
    'cy-italy-game-limit-message' |
    'cy-italy-game-limit-message-section' |
    'cy-italy-game-limit-error-section' |
    'cy-dk-doga-icon' |
    'cy-dk-stop-spillen-icon' |
    'cy-dk-rofus-icon' |
    'cy-clear-search-box-icon' |
    'cy-found-games-list-box' |
    'cy-no-found-games-box' |
    'cy-found-games-more-box' |
    'cy-found-games-more' |
    'cy-search-game-item' |
    'cy-user-cid' |
    'cy-close-mobile-menu-icon' |
    'cy-close-mobile-search-icon' |
    'cy-game-search-input' |
    'cy-search-title-box' |
    'cy-game-search-box' |
    'cy-suggested-links-suggested-games' |
    'cy-lobby-header' |
    'cy-lobby-header-title'|
    'cy-navbar-right-container' |
    'cy-homepage-header-arenas-container' |
    'cy-homepage-top-banner-background' |
    'cy-homepage-top-banner-divider' |
    'cy-arena-box' |
    'cy-header-arena-title' |
    'cy-new-games-arena-badge' |
    'cy-party-jackpot-in-game-container' |
    'cy-party-jackpot-in-game-widget-amount' |
    'cy-party-jackpot-welcome-popup' |
    'cy-party-jackpot-welcome-popup-accept-button' |
    'cy-party-jackpot-welcome-popup-decline-button' |
    'cy-party-jackpot-welcome-popup-terms-and-conditions' |
    'cy-reality-check-close-button' |
    'cy-session-cooldown-popup' |
    'cy-game-popup' |
    'cy-game-popup-not-now-button' |
    'cy-game-popup-open-real-button' |
    'cy-game-popup-game-title' |
    'cy-homepage-arenas-header' |
    'cy-layout-wrapper-homepage'|
    'cy-layout-wrapper-miniorbit-homepage' |
    'cy-lobby-wrapper-miniorbit-arena' |
    'cy-panic-button-germany' |
    'cy-tooltip-click-here' |
    'cy-modal-dialog-content' |
    'cy-tooltip-box' |
    'cy-history-more-details' |
    'cy-details-history-header' |
    'cy-useful-links-list' |
    'cy-mini-orbit-useful-links-list' |
    'cy-tooltip-close' |
    'cy-remainder-select' |
    'cy-more-info' |
    'cy-free-play-indicator-button' |
    'cy-deposit-button' |
    'cy-user-menu-close-btn' |
    'cy-free-play-voucher-container' |
    'cy-free-play-games-container' |
    'cy-free-play-game-item' |
    'cy-drop-down-box' |
    'cy-gaming-history-record' |
    'cy-gaming-history-game-name' |
    'cy-gaming-history-game-image' |
    'cy-gaming-history-play-date' |
    'cy-gaming-history-bet-value' |
    'cy-gaming-history-winning-value' |
    'cy-gaming-history-bankroll-value' |
    'cy-gaming-history-free-play-winning' |
    'cy-gaming-history-free-play-current-amount' |
    'cy-gaming-history-amount-description' |
    'cy-gaming-history-amount-value' |
    'cy-gaming-history-round-id' |
    'cy-migrated-gaming-history-round-id' |
    'cy-gaming-history-session-id' |
    'cy-gaming-history-participation-id' |
    'cy-gaming-history-days-selector' |
    'cy-gaming-history-big-win-message' |
    'cy-gaming-history-loading-trigger' |
    'cy-tipping-history-record' |
    'cy-tipping-history-game-name' |
    'cy-tipping-history-game-image' |
    'cy-tipping-history-tip-id' |
    'cy-tipping-history-play-date' |
    'cy-tipping-history-tip-value' |
    'cy-tipping-history-bankroll-value' |
    'cy-tipping-history-days-selector' |
    'cy-tipping-history-loading-trigger' |
    'cy-tipping-history-amount-description' |
    'cy-tipping-history-amount-value' |
    'cy-skip-intermediate-page' |
    'cy-orbit-swiper' |
    'cy-swiper-button-prev' |
    'cy-swiper-button-next' |
    'cy-uk-malta-reality-check-title' |
    'cy-live-casino-grid' |
    'cy-live-casino-grid-item' |
    'cy-live-casino-grid-item-infobar-game-seats-count-text' |
    'cy-live-casino-grid-item-title' |
    'cy-live-casino-grid-item-bet-interval' |
    'cy-live-casino-grid-item-infobar-draws' |
    'cy-live-casino-grid-item-infobar-dealer-name' |
    'cy-live-casino-grid-item-infobar-bet-behind' |
    'cy-live-casino-widget-amount' |
    'cy-live-casino-widget-description' |
    'cy-history-free-play-message' |
    'cy-user-menu' |
    'cy-games-list-title' |
    'cy-games-title-text' |
    'cy-orbit-swiper-wrapper' |
    'cy-orbit-swiper-games-list' |
    'cy-see-all-link' |
    'cy-recently-played' |
    'cy-help-mobile-link' |
    'cy-filter-link' |
    'cy-open-filters-button' |
    'cy-apply-filters-button' |
    'cy-clear-filters-button' |
    'cy-side-menu' |
    'cy-mini-orbit-side-menu-open-button' |
    'cy-right-drawer' |
    'cy-overlay' |
    'cy-registration-popup-content' |
    'cy-vertical-games-list' |
    'cy-vertical-games-list-close-btn' |
    'cy-lang-switcher-back' |
    'cy-language-switcher-dropdown' |
    'cy-lang-switch-label' |
    'cy-lang-switch-current-lang' |
    'cy-toast-container' |
    'cy-toast' |
    'cy-modal-dialog' |
    'cy-modal-dialog-header' |
    'cy-modal-dialog-consumer-content' |
    'cy-source-of-funds-open-chat-btn' |
    'cy-language-switcher-button' |
    'cy-cms-banner-container' |
    'cy-temp-account-days-number' |
    'cy-temp-account-message-body' |
    'cy-omg-indicator' |
    'cy-jackpot-widget' |
    'cy-cgp-red-tiger-widget-click-detector' |
    'cy-game-jackpot-amount' |
    'cy-useful-links-section' |
    'cy-useful-links-item' |
    'cy-cgp-about-area' |
    'cy-lobby-grid-arena' |
    'cy-link-to-offer-banner-box' |
    'cy-link-to-offer-wheel-of-fortune' |
    'cy-link-to-offer-dialog-close-box' |
    'cy-open-membership-deeplink' |
    'cy-open-cashier-deeplink' |
    'cy-link-to-offer-icon-box'|
    'cy-games-grid-container' |
    'cy-orbit-swiper-streaming-tile' |
    'cy-orbit-swiper-streaming-tile-footer' |
    'cy-cross-brand-link' |
    'cy-arenas-header-button' |
    'cy-live-video-item' |
    'cy-players-like-you' |
    'cy-because-you-played' |
    'cy-game-title' |
    'cy-lists-intersection-observer-target' |
    'cy-inactivity-timeout-select' |
    'cy-about-session-balance-amount' |
    'cy-about-help-link' |
    'cy-filters-games-list' |
    'cy-game-net-position-value' |
    'cy-game-duration-value' |
    'cy-deposit-widget' |
    'cy-deposit-widget-init-params' |
    'cy-payments-redirect-focus' |
    'cy-uk-tsr-main-text-box' |
    'cy-withdraw-button' |
    'cy-cashout-widget' |
    'cy-cashout-widget-init-params' |
    'cy-top-picks-list' |
    'cy-arenas-header' |
    'cy-logo' |
    'cy-main-wrapper' |
    'cy-clock-component' |
    'cy-game-navbar-free-play-indicator' |
    'cy-free-play-vouchers-container' |
    'cy-header-menu-gift-button' |
    'cy-overlay-content' |
    'cy-user-menu-user-details' |
    'cy-user-menu-my-account-button' |
    'cy-state-select-approve-button' |
    'cy-wrong-app-message' |
    'cy-swiper-buttons' |
    'cy-burnout-animation-container' |
    'cy-burnout-gift-button' |
    'cy-tooltip-container' |
    'cy-logo-container' |
    'cy-navbar-container' |
    'cy-user-profile-messages-indicator' |
    'cy-free-play-indicator-dot' |
    'cy-help-widget-app' |
    'cy-header-help-button' |
    'cy-form-post-form' |
    'cy-free-to-play-click-box' |
    'cy-modal-dialog-link' |
    'cy-italy-other-limit-radio' |
    'cy-standard-limit-radio' |
    'cy-jackpot-widget-collecting-amount' |
    'cy-jackpot-widget-amount'|
    'cy-transaction-history-init-params' |
    'cy-transaction-history-widget' |
    'cy-netherlands-ksa-button' |
    'cy-vouchers-previous-button' |
    'cy-vouchers-next-button' |
    'cy-voucher-card-face' |
    'cy-voucher-card-back' |
    'cy-game-restriction-geo-location-primary-button' |
    'cy-game-restriction-geo-location-secondary-button' |
    'cy-header-control-center-button' |
    'cy-control-center-mini-app' |
    'cy-control-center-mini-widget-init-params' |
    'cy-control-center-full-app' |
    'cy-control-center-full-widget-init-params' |
    'cy-header-state-selector-button' |
    'cy-state-select-dropdown' |
    'cy-state-select-other-button' |
    'cy-login-popup-approve-button' |
    'cy-login-modal-content' |
    'cy-login-popup-total-stakes' |
    'cy-login-popup-net-position' |
    'cy-advanced-filters' |
    'cy-applied-advanced-filters-indicator' |
    'cy-applied-advanced-filter-name' |
    'cy-remove-advanced-filter-x-button' |
    'cy-close-advanced-filters-x-button' |
    'cy-mobile-header-search-button' |
    'cy-daily-deal-box' |
    'cy-hybrid-embedded-nav-menu' |
    'cy-hybrid-embedded-nav-menu-list' |
    'cy-hybrid-menu-item' |
    'cy-free-play-on-boarding-tooltip' |
    'cy-control-center-on-boarding-tooltip' |
    'cy-my-account-external-link-container' |
    'cy-registration-external-link-container' |
    'cy-omg-external-link-container' |
    'cy-forgot-password-external-link-container' |
    'cy-forgot-username-external-link-container' |
    'cy-deposit-pending-action-external-link-container' |
    'cy-transaction-history-pending-action-external-link-container' |
    'cy-pending-play-external-link-container' |
    'cy-pending-login-external-link-container' |
    'cy-rich-external-link-container' |
    'cy-upload-documents-external-link-container' |
    'cy-cross-brand-list' |
    'cy-onboarding-tour';



export function CyClass(className: CyCssClass): string {
    return className.toString();
}

export function CySelector(className: CyCssClass): string {
    return '.' + className.toString();
}

export function CySelectors(...classNames: CyCssClass[]): string {
    return classNames.map(clsName => '.' + clsName).join(' ');
}
